// extracted by mini-css-extract-plugin
module.exports = {"modal":"UserTable_modal__2ib8r","modalLabel":"UserTable_modalLabel__M0Q1L","modalValue":"UserTable_modalValue__3h5wC"};